/**
 * Commercial Configuration — Single source of truth for the SaaS commercial model.
 *
 * Change ANY of these values here (price, currency, plan name, trial days,
 * founding member days, features) and the whole app updates automatically.
 *
 * DO NOT hardcode "$199", "10 días", "AgendaPro PRO" in components.
 * Always import from this file.
 */

export const COMMERCIAL = {
  planName: "AgendaPro PRO",
  price: 199,
  currency: "MXN",
  currencySymbol: "$",
  billingCycle: "mes",
  trialDays: 10,
  foundingDays: 90,
  features: [
    "Agenda ilimitada",
    "Página pública",
    "Clientes ilimitados",
    "Servicios ilimitados",
    "Cobro de anticipos",
    "Dashboard",
    "Multi-Nicho",
    "Soporte",
  ],
};

/** Formatted price label, e.g. "$199 MXN / mes". */
export function formatPriceLabel() {
  return `${COMMERCIAL.currencySymbol}${COMMERCIAL.price} ${COMMERCIAL.currency} / ${COMMERCIAL.billingCycle}`;
}

/** Days remaining until an ISO-date (YYYY-MM-DD). Returns null if no date. */
export function daysUntil(isoDate) {
  if (!isoDate) return null;
  const target = new Date(`${isoDate}T23:59:59`);
  if (Number.isNaN(target.getTime())) return null;
  const now = new Date();
  const diffMs = target.getTime() - now.getTime();
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}
